<template>
  <v-card
    :ripple="false"
    @click="playingClip && playingClip.id === clip.id ? closeClip() : openClip(clip); $emit('clicked', clip)"
    link
    :ref="`clip-item-` + clip.id"
    style="transition-duration: 1s;"
    :key="clip.id"
    :class="{ 'highlighted': highlight }"
    class="mb-2"
  >
    <v-list-item dense>
      <!-- {{clip.points}} -->
      <!-- {{ clip }} -->
      <v-list-item-icon>


        <v-icon color="primary" v-if="clip.timenames && clip.timenames.length">
          mdi-timer-outline
        </v-icon>
        <v-icon
          v-else-if="clip.is_point && clip.map_color"
          :color="clip.map_color"
        >
          mdi-tag
        </v-icon>
        <v-icon v-else-if="clip.is_point">
          mdi-tag-outline
        </v-icon>
        <v-icon color="primary" v-else-if="!playingClip || clip.id != playingClip.id">
          mdi-video-outline
        </v-icon>
        <v-icon v-else>
          mdi-chevron-up
        </v-icon>
      </v-list-item-icon>
      <div
        class="my-1"
        style="
          flex-grow: 1;
        "
        v-if="(!clip.title || clip.title === 'New clip') && clip.tags.length"
      >
        <v-chip style="" small v-for="(tag, i) in clip.tags" :key="i + 'cliptag' + clip.id" label outlined>
          {{ tag.name }}
        </v-chip>
      </div>
      <v-list-item-title v-else>
        {{ clip.title }}
      </v-list-item-title>
      <v-chip x-small v-if="clip.num_of_tags">
        {{ clip.num_of_tags }}
      </v-chip>
      <v-chip class="ml-2" small style="width: 70px;" v-if="clip.timenames && clip.timenames.length" label color="primary" outlined>
        {{ secondsToPrettyTimer(totalTime(clip.timenames)) }}
      </v-chip>

      <!-- SETTINGS -->
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-show="!selecting"
            v-if="currentTeamId"
            v-bind="attrs"
            v-on="on"
            text
            fab
            x-small
          >
            <v-icon>
              mdi-dots-vertical
            </v-icon>
          </v-btn>
          <input v-show="selecting" v-model="isSelected" type="checkbox" class="ml-3 mr-2" style="z-index: 4;" @click.stop="$emit('toggleSelection', clip)"/>
        </template>
        <v-list dense>
          <add-to-folder-list-item
            id_type="clip_id"
            type="clip"
            :folder_name="clip.title || 'Clip'"
            :id="clip.id"
          />
          <v-list-item
            @click.stop="editTags = true"
            link
            dense
          >
            <v-list-item-icon>
              <v-icon>mdi-pencil</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{$t('analysis.edit_tags')}}</v-list-item-title>
          </v-list-item>
          <v-list-item
            @click="renaming = true, newName = clip.title"
            link
          >
            <v-list-item-icon>
              <v-icon>mdi-pencil</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{$t('analysis.rename')}}</v-list-item-title>
          </v-list-item>
          <v-list-item
            @click="$router.push(`/editor?clip_id=${clip.id}&from=${$route.path}`)"
            link
            dense
            v-if="!this.$vuetify.breakpoint.mobile"
          >
            <v-list-item-icon>
              <v-icon>mdi-draw</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Grafiikat</v-list-item-title>
          </v-list-item>
          <v-list-item
            @click="startClipExport"
          >
            <v-list-item-icon>
              <v-icon>mdi-download</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              {{ $t('download_clip') }}
            </v-list-item-title>
          </v-list-item>
          <v-divider />
          <v-list-item
            @click="startDeleteClip()"
            link
          >
            <v-list-item-icon>
              <v-icon>mdi-delete</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{$t('delete')}}</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item style="text-align: center;" class="mt-5">
            <share-btn resource_type="clip" :resource_id="clip.id"></share-btn>
          </v-list-item> -->
        </v-list>
      </v-menu>

    </v-list-item>
    <v-expand-transition>
      <div v-if="playingClip && clip.id == playingClip.id">
        <TimeInfo
          v-if="clip.timenames && clip.timenames.length"
          :time="clip"
          @click.stop=""
        ></TimeInfo>
        <ClipInfo
          style="cursor: default;"
          @click.stop=""
          :clip="clip"
        ></ClipInfo>
      </div>
    </v-expand-transition>
    <ChooseFolder
      v-if="choosing"
      :visible="choosing"
      :value="chosenFolders"
      :limit="1"
      :loading="addingToFolder"
      @input="chosenFolders = $event"
      @cancel="choosing = false; chosenFolders = []"
      @set="confirmAddToFolder()"
      :text="$t('analysis.add_to_folder')"
    />
    <ConfirmationDialog
      :show="deleting"
      v-if="deleting"
      :subText="$t('analysis.are_you_sure_clip', [clip.title])"
      btnColor="red"
      :btnText="$t('delete')"
      :text="$t('analysis.delete_clip') + '?'"
      @decline="deleting = false"
      @accept="acceptDeleting()"
    />
    <rename-dialog
      v-model="newName"
      v-if="renaming"
      :visible="renaming"
      @close="renaming = false"
      @rename="rename()"
    />
    <tag-views-dialog
      :show="editTags"
      v-if="editTags"
      v-model="editingTags"
      @close="editTags = false; editingTags = clip && clip.tags ? clip.tags : []"
      @set="saveNewTags(); editTags = false;"
    ></tag-views-dialog>
    <v-dialog v-if="exporting" max-width="800" v-model="exporting">
      <export v-if="exporting" :clip_id="clip.id" @close="exporting = false"></export>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ConfirmationDialog from '@/components/ConfirmationDialog'
import ClipInfo from './ClipInfo'
import ChooseFolder from '@/components/folder/ChooseFolder.vue'
// import ShareBtn from '@/components/share/ShareBtn'
import RenameDialog from '@/components/RenameDialog.vue'
import Export from '@/components/video/export/Export.vue'
import TagViewsDialog from '@/components/tag_views/TagViewsDialog.vue'
import AddToFolderListItem from '@/components/folder/AddToFolderListItem.vue'
import timeMixin from '@/utils/player/time'
import TimeInfo from '@/components/video/analysisBar/time/TimeInfo'

export default {
  mixins: [ timeMixin ],
  props: ['clip', 'titleItem', 'selecting', 'highlight'],
  components: { TimeInfo,
    // ShareBtn,
    ClipInfo, ChooseFolder, ConfirmationDialog, RenameDialog, Export, TagViewsDialog, AddToFolderListItem },
  data: () => ({
    choosing: false,
    chosenFolders: [],
    addingToFolder: false,
    folder: null,
    deleting: false,
    editTags: false,
    editingTags: [],
    renaming: false,
    newName: '',
    exporting: false
  }),
  created() {
    this.editingTags = this.clip?.tags || []
  },
  methods: {
    ...mapActions('player', [
      'openClip',
      'closeClip'
    ]),
    ...mapActions('folder', [
      'addFolder'
    ]),
    ...mapActions('noti', [
      'success',
      'error',
      'info'
    ]),
    ...mapActions('clip', [
      'deleteClip',
      'editClipTags',
      'editClipTitle',
      'exportClip'
    ]),
    startClipExport() {
      this.exporting = true
    },
    confirmAddToFolder() {
      const folder = this.chosenFolders && this.chosenFolders[0]
      if(!folder) return
      this.addToFolder(folder)
    },
    addToFolder(folder) {
      this.addingToFolder = true
      this.addFolder({
        parent: folder.id,
        name: this.clip.title || 'Ei otsikkoa',
        type: 'clip',
        clip_id: this.clip.id
      })
      .then(() => {
        this.success("Klippi lisätty kansioon!")
        this.choosing = false
        this.chosenFolders = []
      })
      .catch(e => this.error(e))
      .finally(() => {
        this.addingToFolder = false
      })
    },
    startDeleteClip() {
      this.deleting = true
    },
    acceptDeleting() {
      this.deleteClip(this.clip.id)
        .then(() => {
          this.info(this.$t('clips.clip_deleted'))
        })
        .catch(e => this.error(e))
        .finally(() => {
          this.deleting = false
        })
    },
    saveNewTags() {
      this.editClipTags({
        tags: this.editingTags.map(t => t.id),
        id: this.clip.id
      })
      .then(() => {
        this.info(this.$t('clips.tags_updated'))
      })
      .catch(e => console.log(e))
    },
    rename() {
        if(!this.newName || this.newName == this.clip.name) {
          this.renaming = false
          return
        }

        this.editClipTitle({id: this.clip.id, title: this.newName})
        .then(() => {
          this.info(this.$t('renamed') + '!')
        })
        .catch(e => this.error(e))
        .finally(this.renaming = false)
      },
  },
  computed: {
    ...mapGetters('player', [
      'playingClip'
    ]),
    ...mapGetters('user', [
      'currentTeamId'
    ]),
    ...mapGetters('batch', [
      'selectedItems'
    ]),
    isSelected: {
      get() {
        return this.selectedItems.some(selectedItem => selectedItem.id === this.clip.id)
      },
      set() {
        // Do nothing - we only use to check the value in a v-model directive
      }
    },
  },
  // POSSIBLE FEATURE
  // watch: {
  //   'highlight': {
  //     handler(newVal) {
  //       let ref = 'clip-item-' + this.clip.id
  //       if(newVal) this.$refs[ref].$el.scrollIntoView({ behavior: 'smooth', block: 'center' })
  //     }
  //   }
  // }
}
</script>

<style scoped>
  input[type="checkbox"] {
  transform:scale(1.3, 1.3);
  }

  .highlighted {
    border-left: 2px solid #3f65ff;
  }
</style>